export default defineAppConfig<any>({
  auth: {
    protectedLayouts: ['account'],
    redirectToAfterLogin: () => (user: any) => {
      const localePath = useLocalePath()

      if (user.agencyId) {
        return externalUrl('agency', { name: 'index' })
      }

      return localePath({ name: 'account' })
    },
  },
})
